<template>
  <div id="mainTest">
    this is test page in work {{cnt}}
  </div>
</template>

<script>


  export default {
    name: "test",
    data:function(){
      return{
        cnt:0
      }
    },
    methods:{
      // workLead(){
      //   this.$myApi.singleRequest({
      //     action:'test_getLead'
      //   }).then((resp)=>{
      //     console.log(resp.counter)
      //     if (parseInt(resp.counter, 10) > 0) {
      //       this.cnt = resp.counter;
      //       this.createJson(resp.arr)
      //     }
      //   });
      // },
      // saveJson(sArr){
      //   this.$myApi.singleRequest({
      //     action:'test_saveLead',
      //     data:sArr
      //   }).then((res)=>{
      //     this.workLead();
      //   });
      // },
      // createJson(arr){
      //   let sendArr = [];
      //   arr.forEach((el) => {
      //     sendArr.push({
      //       id:el.id,
      //       exportJSON:el
      //     })
      //   });
      //   this.saveJson(sendArr);
      // }
    },
    mounted() {
      // this.workLead();



    }
  }
</script>

<style scoped>
#mainTest{padding-left: 100px;}
</style>
